"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createLegendSquare = undefined;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createLegendSquare = exports.createLegendSquare = function createLegendSquare(backgroundColor) {
    return _react2.default.createElement("div", { className: "display-inline-block", style: {
            width: "20px",
            height: "20px",
            background: backgroundColor,
            marginRight: "15px",
            verticalAlign: "bottom",
            borderRadius: "25px"
        } });
};